import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Review_api } from '../../../redux/authslice';

function Modalfeed({ show, onHide, quizz, onReviewChange, navigate, dispatch }) {
    const handleSubmit = () => {
        dispatch(Review_api({navigate, quizz, dispatch}))
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered>
            <Modal.Header closeButton onClick={() => navigate("/history")} style={{ border: 'none' }}>
            </Modal.Header>
            <Modal.Body>
                <p style={{ color: '#62636C', fontWeight: '600', fontSize: '16px', lineHeight: '22px' }}>Share your feedback</p>
                <p style={{ color: '#62636C', fontSize: '12px', fontWeight: '500' }}>Please let us know below what we could improve or what you would like to see differently</p>
                <p style={{ color: '#8B8D98' }}>Feedback</p>
                <textarea
                    style={{
                        width: '100%',
                        height: '226px',
                        padding: '10px',
                        borderRadius: '4px',
                        border: '1px solid #ced4da',
                        fontSize: '14px',
                        color: '#495057',
                        lineHeight: '1.5'
                    }}
                    value={quizz.review}
                    onChange={onReviewChange}
                />
            </Modal.Body>
            <Modal.Footer style={{ border: 'none' }}>
                <button className="Looking-btn" onClick={handleSubmit} disabled={!quizz?.review}>
                    Submit
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default Modalfeed;